// Kanały wykresu w Statystykach (ST-*): wszystkie kanały linii na jednym wykresie, klik w legendę ukrywa kanał, punkty
// na żywo z widoku sztuki (`widok.wykres` - uklad/wykres/zywo.ts). Linia z własnymi kolorami
// (wędzarnia) albo nazwami od klienta (T-4) podaje swoje serie; reszta - kanały z `KANALY_<LINIA>` w kolejnych kolorach
// motywu. Linia spoza listy nie ma wykresu (tablet, tester).
import type { TypLinii, ViewDoc } from "../gen/kontrakt";
import type { WidokTermometrT4 } from "../gen/linie/termometr-t4";
import { KANALY_PIEC } from "../gen/linie/piec";
import { KANALY_STEROWNIK650 } from "../gen/linie/sterownik-650";
import { KANALY_STEROWNIKNOW } from "../gen/linie/sterownik-now";
import type { Seria } from "../uklad/wykres/serie";
import { naZywoZ } from "../uklad/wykres/zywo";
import { KANALY, nazwaKanalu } from "./termometr-t4/stan";
import { SERIE as SERIE_WEDZARNI } from "./wedzarnia-2/stan";

// Pierwszy - kolor linii destylacji (kolumny i T-4 to destylacja; wędzarnia ma własne kolory). Tokeny nowego wyglądu.
const PALETA = ["--iot-destylacja", "--iot-uwaga", "--iot-wykres-seria-3", "--iot-wykres-seria-4", "--iot-wedzenie",
  "--iot-alarm", "--iot-tekst-3"];

type Kanaly = readonly { idx: number; nazwa: string; ukryty: boolean }[];

interface Linia {
  serie: (w: ViewDoc | null) => Seria[];
}

const zOpisu = (k: Kanaly): Linia => ({
  serie: () => k.map((c, i) => ({ idx: c.idx, nazwa: c.nazwa, kolor: PALETA[i % PALETA.length] ?? "--iot-tekst-3", ukryta: c.ukryty })),
});

const LINIE: Partial<Record<TypLinii, Linia>> = {
  "wedzarnia-2": { serie: () => SERIE_WEDZARNI },
  "termometr-t4": {
    serie: (w) => {
      const t4 = w?.type === "termometr-t4" ? (w as unknown as WidokTermometrT4) : null;
      return KANALY.map((k, i) => ({ idx: k.idx, nazwa: nazwaKanalu(t4, k), kolor: PALETA[i] ?? "--iot-tekst-3" }));
    },
  },
  "sterownik-now": zOpisu(KANALY_STEROWNIKNOW),
  "sterownik-650": zOpisu(KANALY_STEROWNIK650),
  piec: zOpisu(KANALY_PIEC),
};

/** Czy linia ma wykres w Statystykach. */
export function maWykres(typ: TypLinii): boolean {
  return typ in LINIE;
}

/** Serie i odczyt na żywo wykresu sztuki; null = linia bez wykresu. */
export function wykresLinii(typ: TypLinii, w: ViewDoc | null) {
  const l = LINIE[typ];
  if (!l) return null;
  const serie = l.serie(w);
  return { serie, naZywo: naZywoZ(serie.map((s) => s.idx)) };
}
